import { Outlet } from "react-router-dom";

// rafce if you have react ex7 snippet extension  
import React from 'react'

const Layout = () => {
  return <Outlet></Outlet>
}

export default Layout